import React, { memo, useLayoutEffect, useRef } from 'react';

import { CameraListUIComponent } from "../../ui";
import CameraListTitleComponent from "../CameraListTitleComponent";
import { adjustCameraElement } from "../../../utils";
import './style.css';

interface CameraStoreInterface {
  name: string
}

interface Props {
  openedCameraList: boolean,
  searchHandler: (event: React.FormEvent<HTMLInputElement>) => void,
  pane: number,
  typedValue: string,
  onCameraSelect: (name: string) => any,
  cameras: any[]
}

// TODO, change logic fo SGS map select
// block clicking while loading information for map etc

const CameraListComponent: React.FC<Props> = ({openedCameraList, searchHandler, pane, cameras, typedValue, onCameraSelect}) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => adjustCameraElement(ref.current), [openedCameraList]);

  return (
    <div className='cameralist'>
      {
        openedCameraList && (
          <div className='pos-rel'>
            <div className='pos-abs cameralist-content' ref={ref}>
              <CameraListTitleComponent
                searchHandler={searchHandler}
                value={typedValue}
              />
              <div className='title-padding'/>
              <ul className='list-cameras scroll'>
                {
                  cameras
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(({name}: CameraStoreInterface, i: number) => (
                      <li className='list-cameras-item'
                          key={name + i}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            onCameraSelect(name)
                          }}
                      >
                        {name}
                      </li>
                    ))
                }
              </ul>
            </div>
          </div>
        )

      }
      <CameraListUIComponent/>
    </div>
  )
};


export default memo(CameraListComponent)